import React from 'react'
import './index.less'

interface Props {
  visible: boolean,
  onClose: () => void,
  iconUrl: string,
  title: string,
  subTitle?: string,
  showBg?: boolean,
  showButton?: boolean,
  buttonText?: string,
}

const App = (props: Props) => {
  return (
    props.visible ? (
      <div className='prize-dialog'>
        <div className='modal' onClick={props.onClose}></div>
        <div className='content'>
          { props.showBg && <div className='prize-bg'></div> }
          { props.iconUrl && <img className='icon' alt='' src={props.iconUrl} /> }
          <div className='main-title'>{props.title}</div>
          { props.subTitle && <div className='sub-title'>{props.subTitle}</div> }
          { props.showButton && <div className='button' onClick={props.onClose}>{props.buttonText}</div> }
        </div>
      </div>
    ) : null
  )
}

export default App